<template>
  <v-menu ref="dpMenu" v-model="dpMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
    <template v-slot:activator="{ on }">
      <v-text-field readonly v-on:input="$emit('input', $event)" v-on="on" :value="formatDate(value)" prepend-icon="mdi-calendar">
        <template v-slot:label>{{ $t(label) }} </template>
      </v-text-field>
    </template>
    <v-date-picker v-model="selDate" :min="min" @input="dpMenu = false" no-title />
  </v-menu>
</template>

<script>
import moment from "moment";

export default {
  name: "date-input",
  props: {
    label: String,
    min: [Date, String],
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dpMenu: null,
      date: null,
    };
  },

  computed: {
    selDate: {
      get() {
        console.log(moment(this.value).format());
        return moment(this.value).format();
      },

      set(value) {
        this.$emit("input", moment(value).format("DD/MMM/YYYY"));
      },
    },

    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },

  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
    },
  },

  methods: {
    formatDate(date) {
      if (!date) return null;

      let strDate = date.split("T")[0];
      const [year, month, day] = ~strDate.indexOf("/") ? strDate.split("/") : strDate.split("-");
      console.log(year, month, day);
      return `${year}/${month}/${day}`;
    },

    parseDate(date) {
      if (!date) return null;

      let strDate = date.split("T")[0];
      const [month, day, year] = ~strDate.indexOf("/") ? strDate.split("/") : strDate.split("-");
      console.log();
      return `${month}-${day.padStart(2, "0")}-${year.padStart(2, "0")}`;
    },
  },
};
</script>
